/**
 * site.ts — carregado em todas as páginas via _Layout.cshtml
 */

import { initMasks, initMoneyInputs, setMoneyField } from '@helpers/masks';
import Toast from '@components/toast';

// Exporta globals para uso em scripts inline das views
(window as any).Toast = Toast;
(window as any).setMoneyField = setMoneyField;

document.addEventListener('DOMContentLoaded', () => {
    initMasks();
    initMoneyInputs();
});

// ── Page Loader ───────────────────────────────────────────────────────────────
window.addEventListener('load', () => {
    const loader = document.getElementById('pageLoader');
    if (!loader) return;

    // Garante tempo mínimo de exibição (400ms) para não piscar em conexões rápidas
    const minDisplay = 400;
    const elapsed = performance.now();
    const remaining = Math.max(0, minDisplay - elapsed);

    setTimeout(() => loader.classList.add('hidden'), remaining);
});
